import { render, staticRenderFns } from "./loginDialog.vue?vue&type=template&id=00620778&scoped=true"
import script from "./loginDialog.vue?vue&type=script&lang=js"
export * from "./loginDialog.vue?vue&type=script&lang=js"
import style0 from "./loginDialog.vue?vue&type=style&index=0&id=00620778&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00620778",
  null
  
)

export default component.exports